import { createTagsId } from "@repo/fika-shared/src/loader/tags-schema"
import type { GraphCacheOptimisticUpdaters } from "@/graphql/generated"

export const tagsOptimisticUpdaters = {
  setTags: variables => ({
    __typename: "MutationSetTagsSuccess",
    data: {
      __typename: "Tags",
      id: createTagsId(variables.targetType, variables.targetId),
      tags: variables.tags,
    },
  }),
} satisfies GraphCacheOptimisticUpdaters
